<app-vault-module-shell
  moduleLabel="Retención Documental"
  [accessDenied]="store.accessDenied()"
  [loadError]="store.loadError()"
  [loadErrorTitle]="store.loadErrorTitle() ?? 'No se pudo cargar Retención Documental'"
>
<section class="retention">
  <app-page-header
    title="Retención Documental"
    subtitle="Configura políticas de retención y define su estado operativo."
    icon="ArchiveRestore"
    [actions]="headerActions()"
    (actionClick)="onHeaderAction($event)"
  />

  @if (loading()) {
    <div class="loading-container">
      <lib-empty message="Cargando políticas de retención" description="Espere por favor..." />
    </div>
  }
  @if (error()) {
    <app-vault-page-alert
      type="error"
      title="Error"
      [message]="error()"
      (closed)="store.clearPageError()"
    />
  }
  @if (info()) {
    <app-vault-page-alert
      type="info"
      title="Aviso"
      [message]="info()"
      (closed)="store.clearPageInfo()"
    />
  }

  <div class="retention__sections">
    <div class="retention__sections-group">
      <lib-button
        class="retention__section-btn"
        [variant]="activeSection() === 'policies' ? 'primary' : 'secondary'"
        type="button"
        (clicked)="setActiveSection('policies')"
      >
        Políticas
      </lib-button>
      <lib-button
        class="retention__section-btn"
        [variant]="activeSection() === 'documents' ? 'primary' : 'secondary'"
        type="button"
        (clicked)="setActiveSection('documents')"
      >
        Documentos
      </lib-button>
      <lib-button
        class="retention__section-btn"
        [variant]="activeSection() === 'expiring' ? 'primary' : 'secondary'"
        type="button"
        (clicked)="setActiveSection('expiring')"
      >
        Próximos a vencer
      </lib-button>
    </div>
  </div>

  @if (activeSection() === 'policies') {

  @if (creating()) {
  <fieldset class="retention__fieldset retention__edit-panel">
    <legend>Nueva política</legend>
    <div class="retention__form-row">
    @for (_ of [createFormResetKey()]; track _) {
    <app-grid-form preset="responsive" wrapperClass="retention__form-grid">
      <app-grid-form-item [span]="2" class="retention-field">
        <app-field-label label="Nombre" [required]="true" tooltip="Nombre visible de la política." />
        <lib-input
          label=""
          [externalLabel]="true"
          placeholder="Ej: Retención contratos"
          [value]="createForm().name"
          (valueChange)="onCreateField('name', $event)"
        />
        <app-vault-form-validation-alert [message]="store.createNameError()" />
      </app-grid-form-item>

      <app-grid-form-item [span]="2" class="retention-field">
        <app-field-label
          label="Tipo de documento"
          [required]="true"
          tooltip="Clasificación del documento al que aplica la política."
        />
        <lib-select
          label=""
          [options]="documentTypeOptions"
          [value]="createForm().document_type"
          (valueChange)="onCreateField('document_type', $event)"
        />
      </app-grid-form-item>

      <app-grid-form-item [span]="1" class="retention-field">
        <app-field-label
          label="Periodo"
          [required]="true"
          tooltip="Cantidad numérica del tiempo de retención (ej. 5)."
        />
        <lib-input
          label=""
          placeholder="Ej: 5"
          [value]="toInputValue(createForm().retention_period)"
          (valueChange)="onCreateField('retention_period', +($event || 0))"
        />
      </app-grid-form-item>

      <app-grid-form-item [span]="1" class="retention-field">
        <app-field-label
          label="Unidad"
          [required]="true"
          tooltip="Unidad de tiempo del periodo: días, meses o años."
        />
        <lib-select
          label=""
          [options]="unitOptions"
          [value]="createForm().retention_unit"
          (valueChange)="onCreateField('retention_unit', $event)"
        />
      </app-grid-form-item>

      <app-grid-form-item [span]="2" class="retention-field">
        <app-field-label
          label="Acción al vencer"
          [required]="true"
          tooltip="Qué ocurre al finalizar el plazo: eliminar, archivar o revisión."
        />
        <lib-select
          label=""
          [options]="actionOptions"
          [value]="createForm().disposition_action"
          (valueChange)="onCreateField('disposition_action', $event)"
        />
      </app-grid-form-item>

      <app-grid-form-item [span]="2" class="retention-field">
        <app-field-label label="Descripción" tooltip="Detalle adicional de uso de la política." />
        <lib-input
          label=""
          placeholder="Opcional"
          [value]="createForm().description"
          (valueChange)="onCreateField('description', $event)"
        />
      </app-grid-form-item>

      <app-grid-form-item [span]="1" class="retention-field">
        <app-field-label
          label="Notificar antes (días)"
          tooltip="Días de anticipación para alertar antes del vencimiento."
        />
        <lib-input
          label=""
          [value]="toInputValue(createForm().notify_days_before)"
          (valueChange)="onCreateField('notify_days_before', +($event || 0))"
        />
      </app-grid-form-item>

      <app-grid-form-item [span]="1" class="retention-field">
        <app-field-label label="Fecha de referencia" tooltip="Fecha base sugerida para aplicar retención." />
        <lib-datepicker
          label=""
          [value]="createForm().retention_start_date"
          (valueChange)="onCreateField('retention_start_date', $event)"
        />
      </app-grid-form-item>

      <app-grid-form-item [span]="'full'" class="retention-field">
        <lib-checkbox
          label="Política activa"
          [checked]="createForm().is_active"
          (checkedChange)="onCreateField('is_active', $event)"
        />
      </app-grid-form-item>
    </app-grid-form>
    }
    <div class="retention__form-actions">
      <lib-button
        variant="primary"
        type="button"
        prefixIcon="Plus"
        [disabled]="saving() || loading()"
        [loading]="saving()"
        (clicked)="createPolicy()"
      >
        Crear política
      </lib-button>
      <lib-button variant="secondary" type="button" [disabled]="saving()" (clicked)="closeCreatePanel()">
        Cancelar
      </lib-button>
    </div>
    </div>
  </fieldset>
  }

  @if (editingId()) {
    <fieldset #editPanel class="retention__fieldset retention__edit-panel">
      <legend>Editar política</legend>
      @if (retentionEditRecordIdHint(editingId()); as hint) {
        <p class="retention__hint">{{ hint }}</p>
      }

      <app-grid-form preset="responsive" wrapperClass="retention__form-grid">
        <app-grid-form-item [span]="2" class="retention-field">
          <app-field-label
            label="Nombre"
            [required]="true"
            tooltip="Nombre visible de la política."
          />
          <lib-input
            label=""
            [externalLabel]="true"
            placeholder="Ej: Retención contratos"
            [value]="editForm().name"
            (valueChange)="onEditField('name', $event)"
          />
          <app-vault-form-validation-alert [message]="store.editNameError()" />
        </app-grid-form-item>
        <app-grid-form-item [span]="2" class="retention-field">
          <app-field-label
          label="Tipo de documento"
          [required]="true"
          tooltip="Clasificación del documento al que aplica la política."
        />
          <lib-select
            label=""
            [options]="documentTypeOptions"
            [value]="editForm().document_type"
            (valueChange)="onEditField('document_type', $event)"
          />
        </app-grid-form-item>
        <app-grid-form-item [span]="1" class="retention-field">
          <app-field-label
          label="Periodo"
          [required]="true"
          tooltip="Cantidad numérica del tiempo de retención (ej. 5)."
        />
          <lib-input
            label=""
            placeholder="Ej: 5"
            [value]="toInputValue(editForm().retention_period)"
            (valueChange)="onEditField('retention_period', +($event || 0))"
          />
        </app-grid-form-item>
        <app-grid-form-item [span]="1" class="retention-field">
          <app-field-label
          label="Unidad"
          [required]="true"
          tooltip="Unidad de tiempo del periodo: días, meses o años."
        />
          <lib-select
            label=""
            [options]="unitOptions"
            [value]="editForm().retention_unit"
            (valueChange)="onEditField('retention_unit', $event)"
          />
        </app-grid-form-item>
        <app-grid-form-item [span]="2" class="retention-field">
          <app-field-label
          label="Acción al vencer"
          [required]="true"
          tooltip="Qué ocurre al finalizar el plazo: eliminar, archivar o revisión."
        />
          <lib-select
            label=""
            [options]="actionOptions"
            [value]="editForm().disposition_action"
            (valueChange)="onEditField('disposition_action', $event)"
          />
        </app-grid-form-item>
        <app-grid-form-item [span]="2" class="retention-field">
          <app-field-label label="Descripción" tooltip="Detalle adicional de uso de la política." />
          <lib-input
            label=""
            placeholder="Opcional"
            [value]="editForm().description"
            (valueChange)="onEditField('description', $event)"
          />
        </app-grid-form-item>
        <app-grid-form-item [span]="1" class="retention-field">
          <app-field-label
          label="Notificar antes (días)"
          tooltip="Días de anticipación para alertar antes del vencimiento."
        />
          <lib-input
            label=""
            [value]="toInputValue(editForm().notify_days_before)"
            (valueChange)="onEditField('notify_days_before', +($event || 0))"
          />
        </app-grid-form-item>
        <app-grid-form-item [span]="1" class="retention-field">
          <app-field-label label="Fecha de referencia" tooltip="Fecha base sugerida para aplicar retención." />
          <lib-datepicker
            label=""
            [value]="editForm().retention_start_date"
            (valueChange)="onEditField('retention_start_date', $event)"
          />
        </app-grid-form-item>
        <app-grid-form-item [span]="'full'" class="retention-field">
          <lib-checkbox
            label="Política activa"
            [checked]="editForm().is_active"
            (checkedChange)="onEditField('is_active', $event)"
          />
        </app-grid-form-item>
        <app-grid-form-item [span]="'full'">
          <div class="retention__edit-actions">
            <lib-button variant="primary" [loading]="saving()" (clicked)="saveEdit()">Guardar</lib-button>
            <lib-button variant="secondary" [disabled]="saving()" (clicked)="cancelEdit()">Cancelar</lib-button>
          </div>
        </app-grid-form-item>
      </app-grid-form>
    </fieldset>
  }

  @if (!loading() && filteredPolicies().length > 0) {
    @if (selectedPolicy(); as policy) {
      <section class="retention__detail" aria-labelledby="retention-policy-detail-title">
        <div class="retention__detail-toolbar">
          <div class="retention__detail-title-wrap">
            <p class="retention__detail-kicker">Consulta de política</p>
            <h3 id="retention-policy-detail-title">{{ policy.name }}</h3>
          </div>
          <div class="retention__detail-actions">
            <lib-button
              variant="secondary"
              type="button"
              prefixIcon="Pencil"
              (clicked)="startEdit(policy)"
            >
              Editar
            </lib-button>
            <lib-button
              variant="secondary"
              type="button"
              prefixIcon="X"
              (clicked)="closePolicyDetail()"
            >
              Cerrar
            </lib-button>
          </div>
        </div>
        <dl class="retention__detail-grid">
          @for (field of policyDetailFields(policy); track field.label) {
            <div class="retention__detail-item">
              <dt>{{ field.label }}</dt>
              <dd>{{ field.value }}</dd>
            </div>
          }
        </dl>
      </section>
    }

    <div class="retention__table-wrap">
      <lib-search
        placeholder="Buscar política..."
        [searchTerm]="searchTerm()"
        (searchTermChange)="onSearchTermChange($event)"
        [loading]="loading()"
      />
      <lib-table
        [config]="tableConfig()"
        [data]="filteredPolicies()"
        [loading]="loading()"
        [searchTerm]="searchTerm()"
        (searchTermChange)="onSearchTermChange($event)"
        [sortColumn]="sortColumn()"
        [sortDirection]="sortDirection()"
        (sortChange)="onSortChange($event)"
        [pageSize]="policiesTablePageSize()"
        [pageSizeOptions]="tablePageSizeOptions"
        (pageChange)="onPoliciesTablePageChange($event)"
        (action)="onTableAction($event)"
      >
        <ng-template #cellTemplate let-row let-column="column">
          @if (column.key === 'activeLabel') {
            <lib-badge
              [text]="row.activeLabel"
              [variant]="row.is_active ? 'success' : 'neutral'"
              size="small"
            />
          }
          @if (column.key === '_actions') {
            <div class="retention__row-actions" (click)="$event.stopPropagation()">
              <lib-button
                variant="icon-ghost"
                type="button"
                prefixIcon="Eye"
                [iconSize]="20"
                ariaLabel="Consultar política"
                (clicked)="onPolicyRowAction('view', row)"
              />
              <lib-button
                variant="icon-ghost"
                type="button"
                prefixIcon="Pencil"
                [iconSize]="20"
                ariaLabel="Editar política"
                (clicked)="onPolicyRowAction('edit', row)"
              />
              <lib-button
                variant="icon-ghost"
                type="button"
                [prefixIcon]="row.is_active ? 'LockOpen' : 'Lock'"
                [iconSize]="20"
                [ariaLabel]="row.is_active ? 'Desactivar política' : 'Activar política'"
                (clicked)="onPolicyRowAction('toggle', row)"
              />
              <lib-button
                variant="icon-ghost"
                type="button"
                prefixIcon="Trash2"
                [iconSize]="20"
                ariaLabel="Eliminar política"
                (clicked)="onPolicyRowAction('delete', row)"
              />
            </div>
          }
        </ng-template>
      </lib-table>
    </div>
  }

  @if (!loading() && !error() && filteredPolicies().length === 0 && !editingId()) {
    <lib-empty
      icon="ArchiveRestore"
      message="Sin políticas de retención"
      description="Crea la primera política para activar el módulo de retención."
    />
    <div class="vault-empty-cta">
      <lib-button variant="secondary" type="button" prefixIcon="RefreshCcw" (clicked)="onHeaderAction('reload')">
        Actualizar
      </lib-button>
    </div>
  }

  } @else if (activeSection() === 'documents') {
    <div class="retention__table-wrap">
      <div class="retention__documents-filters">
        <lib-search
          placeholder="Buscar por documento o política..."
          [searchTerm]="retentionSearchTerm()"
          (searchTermChange)="onRetentionSearchTermChange($event)"
          [loading]="loading()"
        />
        <lib-select
          label=""
          [options]="retentionStatusOptions"
          [value]="retentionStatusFilter()"
          (valueChange)="onRetentionStatusFilterChange($event)"
        />
      </div>

      <lib-table
        [config]="documentsTableConfig()"
        [data]="filteredRetentions()"
        [loading]="loading()"
        [searchTerm]="retentionSearchTerm()"
        (searchTermChange)="onRetentionSearchTermChange($event)"
        [pageSize]="documentsTablePageSize()"
        [pageSizeOptions]="tablePageSizeOptions"
        (pageChange)="onDocumentsTablePageChange($event)"
        (action)="onDocumentTableAction($event)"
      >
        <ng-template #cellTemplate let-row let-column="column">
          @if (column.key === 'stateLabel') {
            <lib-badge [text]="row.stateLabel" [variant]="row.stateVariant" size="small" />
          }
        </ng-template>
      </lib-table>
    </div>

    @if (!loading() && filteredRetentions().length === 0) {
      <lib-empty
        icon="ArchiveRestore"
        message="No hay documentos bajo retención"
        description="Aún no hay calendarios creados o no coinciden con el filtro."
      />
    }
  } @else {
    <app-retention-calendar [documents]="expiringDocs()" [daysWindow]="30" />

    @if (!loading() && expiringDocs().length === 0) {
      <lib-empty
        icon="ArchiveRestore"
        message="Sin vencimientos próximos"
        description="No hay documentos que venzan en los próximos 30 días."
      />
    }
  }

</section>
</app-vault-module-shell>
